import { Result } from '@hitiq/generic';
import { Logger, LogType } from '@hitiq/logger';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { Persistance } from '../../dataStorePersistence/persistence';
import { Translator } from '../translator.interface';
import { Conneqt, ConneqtBackend } from './conneqt.interfaces';

export const loadConneqtThunk = createAsyncThunk(
  'conneqt/loadThunk',
  async (
    payload: {
      translator: Translator<ConneqtBackend, Conneqt>;
      persistence: Persistance<ConneqtBackend>;
      loggingService: Logger;
    },
    thunkAPI,
    // TODO: figure out return type of rejectWithValue something like RejectWithValue<Alert>
  ): Promise<boolean | any> => {
    const { loggingService, persistence, translator } = payload;

    const results = await persistence.getAll();

    if (results.error) {
      return thunkAPI.rejectWithValue({
        heading: 'Unable to load conneqt',
        message: results.error.message,
        severity: 'error',
        id: uuidv4(),
      });
    }

    const usersResources = results.data;

    // QUESTION: do we need translation here?
    // return translator.translate(usersResources);

    return usersResources;
  },
);
